import { useState } from 'react';

import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';
import { ICartEntry } from 'features/cart/types';
import { Text } from 'react-native';
import { Icon } from 'ucl/components/icon/Icon';

import ConfirmDialog from 'components/confirm-dialog';
import { t } from 'state/intl/translations';
import { HapticsNotificationType, hapticNotification } from 'utils/haptic';

import { cartActionsStyles } from './cart-actions-styles';
import { CartEntryActionButton } from './cart-entry-action-button';

export const CartEntryDeleteButton = ({
  cartEntry,
  variant,
  disabled,
}: {
  cartEntry: ICartEntry;
  variant: 'textOnly' | 'iconOnly';
  disabled?: boolean;
}) => {
  const { removeItemFromMinimalCart } = useMinimalCart();
  const [showDeleteConfirmationDialog, setShowDeleteConfirmationDialog] = useState(false);

  const handleRemoveItem = () => {
    hapticNotification({ type: HapticsNotificationType.WARNING });
    setShowDeleteConfirmationDialog(true);
  };

  const handleConfirmRemoveItem = () => {
    setShowDeleteConfirmationDialog(false);
    removeItemFromMinimalCart(cartEntry);
  };

  return (
    <>
      {variant === 'textOnly' && (
        <CartEntryActionButton
          accessibilityLabel={`${t('remove')} ${cartEntry.name} `}
          testID="remove-cart-entry-button"
          onPress={handleRemoveItem}
          disabled={disabled}
        >
          <Text style={cartActionsStyles.removeText}>{t('remove')}</Text>
        </CartEntryActionButton>
      )}
      {variant === 'iconOnly' && (
        <CartEntryActionButton
          accessibilityLabel={`${t('remove')} ${cartEntry.name} `}
          testID="remove-cart-entry-button"
          onPress={handleRemoveItem}
          icon={<Icon variant="bkRemove" size="md" />}
          disabled={disabled}
        />
      )}
      <ConfirmDialog
        showDialog={showDeleteConfirmationDialog}
        heading={t('removeItem')}
        body={t('removeItemFromCart', {
          item: cartEntry.name,
          offerText: '',
        })}
        confirmLabel={t('okay')}
        cancelLabel={t('cancel')}
        onConfirm={handleConfirmRemoveItem}
        onCancel={() => {
          setShowDeleteConfirmationDialog(false);
        }}
        modalAppearanceEventMessage={''}
      />
    </>
  );
};
